import "../../App/App.css";
const Contacto = () => {
  return (
    <div>
      <h1 className="contacto">Contacto</h1>
    </div>
  );
};
export default Contacto;
